export default __webpack_public_path__ + "10b891b7e240f01ac150a600467001ae.woff2";